import { BlockTitle } from "@blocks/Blocks";
import AboutSection from "@ee/components/FAQ/components/About/AboutSections";
import DocumentationSection from "@ee/components/FAQ/components/Documentation/DocumentationSection";
import ShortListingSection from "@ee/components/FAQ/components/ShortListing/ShortListingSection";
import WinnersSection from "@ee/components/FAQ/components/Winners/WinnersSection";

/**
 * Component to FAQ Page
 */
const EEFAQPage = (): React.ReactElement => {
  return (
    <div data-testid="ee-faq-page-component" className="mb-5 font-public-sans">
      <BlockTitle
        text="FAQ"
        rootClassName="text-4xl md:text-6xl lg:text-8xl font-medium mb-6 font-poppins"
      />

      <AboutSection />

      <WinnersSection />

      <ShortListingSection />

      <DocumentationSection />

      <div className="bg-gray-150 px-4 pb-4 leading-[1.4]">
        <p className="pt-12 text-center">Disclaimer:</p>

        <p>
          No representation or warranty whatsoever (including without limitation
          any representation or warranty as to accuracy, usefulness, adequacy,
          timeliness or completeness) in respect of any information (including
          without limitation any statement, figures, opinion, view or estimate)
          provided herein is given by the Award Organiser (including without
          limitation OCBC) and it should not be relied upon as such. The Award
          Organiser (including without limitation OCBC) does not undertake an
          obligation to update the information or to correct any inaccuracy that
          may become apparent at a later time.
        </p>

        <p>
          All information presented is subject to change without notice. The
          Award Organiser (including without limitation OCBC) shall not be
          responsible or liable for any loss or damage whatsoever arising
          directly/indirectly howsoever in connection with or as a result of any
          person acting on any information provided herein.
        </p>

        <p>
          In this FAQ, there may be references to links or hyperlinks which link
          you to websites of other third parties (the “Third Parties”). OCBC
          hereby disclaims liability for any information, materials, products or
          services posted or offered on the website of the Third Parties.
          Further, OCBC is not responsible for and makes no representations or
          warranties in respect of the Third Parties’ websites, nor in respect
          of any products, services or information provided by such Third
          Parties.
        </p>

        <p>
          OCBC shall not be responsible or liable for any damage, loss,
          liability, expense or other consequences suffered or incurred by you,
          including without limitation, direct, indirect, special or
          consequential damage or economic loss, arising from or in connection
          with your access to the Third Parties’ websites.
        </p>
      </div>
    </div>
  );
};

export default EEFAQPage;
